import * as React from 'react';

import { todo } from './todo.module.css';

const ToDo = ({ children }) => {
  return <span className={todo}>🚧   {children}</span>;
};
export default ToDo;
